var tableLoading = false;
var tablesLoadedCount = 0;

var maintenanceUtils = {
    getFileName : function(uglyName) {
        /* this is the only way to get file name in IE9, 
         * but for chrome we have to remove fake path */
        var matches = /(?:.*[\\\/])?(.*$)/i.exec(uglyName);
        return matches[1];  
    },
    validateFileExtension : function(fileName) {
        var matches = /.*\.(zip$)/i.exec(fileName);
        return (!!matches);
    },
    getData : function(resource) {
        // make ajax call, keep returned promise instead of invoking callback directly
        var promise = $.getJSON(resource, {
            nocache: new Date().getTime()
        });
        
        return promise;
    },
    validateResponse : function(data, expectedItem) {
        if (data.success == false ||  !(expectedItem in data)){
            return false;
        } else { 
            return true;
        }
    }
};

var tableLoadedHandler = function() {
    if (tableLoading && tablesLoadedCount === 2) {
        tablesLoadedCount = 0;
        tableLoading = false;
        $.removeLoadingIndicator();
    }
};

$(document).on('tableLoading', function() {
    if (!tableLoading) {
        tableLoading = true;
        $.displayLoadingIndicator(loadingText, '.main-contents');
    }
});

$(document).on('tableLoaded', function() {
    tablesLoadedCount++;
    tableLoadedHandler();
});